module.exports = __webpack_public_path__ + "img/function_05.dcbf0f94.png";